import type { SVGProps } from 'react';

const QuestionMarkInCircleIcon = ({
  width = 16,
  height = 16,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    data-palette="QuestionMarkInCircleIcon">
    <path
      fill="currentColor"
      d="M8 15.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m-.75-3.75h1.5v1.5h-1.5zm1.5-1.234V9.5h-1.5V8.375a.75.75 0 0 1 .75-.75 1.125 1.125 0 1 0-1.103-1.346l-1.472-.294A2.626 2.626 0 1 1 8.75 9.016"
    />
  </svg>
);

export default QuestionMarkInCircleIcon;
